/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseChannel } from '../../models/api-response-channel';
import { Channel } from '../../models/channel';

export interface UpdateChannel$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  ref: string;
      body: Channel
}

export function updateChannel(http: HttpClient, rootUrl: string, params: UpdateChannel$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseChannel>> {
  const rb = new RequestBuilder(rootUrl, updateChannel.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('ref', params.ref, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseChannel>;
    })
  );
}

updateChannel.PATH = '/v1/api/ui/channel/{ref}';
